<template>
  <v-container class="login-container">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <form autocomplete="off">
        <v-col align="center">
        <!-- 
          <v-img
            style="margin-bottom: 1rem"
            width="240"            
            contain
            src="@/assets/logo.svg"
          />
        -->
        <!--
            padding="100px 0px 0px 0px"      
            width="248"
            height="248" 
        -->
          <v-img
            style="margin-bottom: 1rem"
        
            contain
            src="@/assets/logo_image.svg"
          />

        </v-col>
        <!-- <p class="web3pays-subtitle white--text mt-4">
          Web 3.0 기반 통합 포인트<br />장애인후원 포인트 주관사
        </p> -->
        
        <!-- <validation-provider name="emil" rules="required|email">
          <v-text-field
            type="email"
            :label="$t('login.id')"
            v-model.trim="email"
            ref="email"
            v-on:keyup.enter="focusPassword"
          ></v-text-field>
        </validation-provider>
        <validation-provider name="password" rules="required">
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :label="$t('login.password')"
            v-model.trim="password"
            @click:append="showPassword = !showPassword"
            v-on:keyup.enter="submit"
            ref="password"
          ></v-text-field>
        </validation-provider> -->
        <!-- <div class="text-h5 font-weight-bold">안녕하세요.</div>
        <div class="text-h5 font-weight-bold">
          <span class="primary--text">PLAPAY</span> 입니다.
        </div>
        <div class="text-h5 font-weight-bold">휴대전화 번호를 입력하세요.</div> -->
        <validation-provider ref="phone" name="phone" rules="required">
          <v-text-field
            type="number"
            placeholder="01000000000"
            v-model="phone"
            class="my-4 text-h5"
            hide-details
            @keypress="onKeydown"
            v-on:keyup.enter="submit"
          >
          </v-text-field>
        </validation-provider>
        <v-alert
          v-model="alert"
          type="error"
          dense
          outlined
          transition="scroll-y-transition"
          class="text-body-2"
        >
          {{ errors }}
        </v-alert>

        <!-- <v-row align-content="center" justify="space-between">
          <div>
            <v-checkbox v-model="autoLogin">
              <template v-slot:label>
                <span class="text-subtitle-2 font-weight-bold">{{
                  $t('login.autoLogin')
                }}</span>
              </template>
            </v-checkbox>
          </div>
          <div class="links">
            <router-link class="link-item" to="/signup">
              <span class="text-subtitle-2 font-weight-bold">{{
                $t('login.signup')
              }}</span>
            </router-link>
            <router-link class="link-item" to="/password">
              <span class="text-subtitle-2 font-weight-bold">
                {{ $t('login.forgot') }}
              </span>
            </router-link>
          </div>
        </v-row> -->
        <v-btn
          @click="submit"
          class="font-weight-bold bottom-disable-p"
          color="primary"
          block
          x-large
          :disabled="loading || invalid"
        >
          로그인 / 회원가입
        </v-btn>
      </form>
    </validation-observer>
    
  </v-container>
</template>

<script>
import { required, email } from 'vee-validate/dist/rules'
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate'
import { loginSuccess } from '@/api/native/native'

setInteractionMode('eager')

export default {
  data: () => ({
    phone: '',
    token: '',
    errors: '',
    autoLogin: false,
    alert: false,
    showPassword: false,
  }),
  props: ['recommend'],

  computed: {
    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    extend('required', {
      ...required,
      message: this.$t('login.requiredMessage'),
    })
    extend('email', {
      ...email,
      message: this.$t('login.emailMessage'),
    })

      console.log("recommend : " , this.recommend   )  ;

    if (this.$route.query.psite) this.$cookies.set('psite', this.$route.query.psite) ; 
    
    this.$cookies.remove('recommend')
    if ( this.recommend  ) {      
      this.$cookies.set('recommend',  this.recommend  )
    }  ; 
  },
  methods: {
    onKeydown(e) {
      if (
        e.keyCode === 101 ||
        e.keyCode === 69 ||
        e.keyCode === 45 ||
        e.keyCode === 43
      )
        e.preventDefault()
      if (e.target.value.length > 10) e.preventDefault()
    },
    focusPassword() {
      this.$refs.password.focus()
    },
    filterKo() {
      const koreanRegex = /[ㄱ-ㅎㅏ-ㅣ가-힣]/g
      return this.password.replace(koreanRegex, '')
    },
    submit() {
      this.$store.commit('loading', true)



      if (this.$refs.observer.validate()) {
        const params = {
          phone: this.phone.trim(),
          token: this.token.trim(),
        }

        const regx = /^01([0|1|6|7|8|9])([0-9]{3,4})([0-9]{4})$/
        if ( !regx.test(params.phone)) { 
          this.$store.commit('loading', false)
          this.alert = true
          this.errors = '올바른 휴대폰 번호를 입력해주세요.' ;           
          return ; 
        }  ; 


        this.$store
          .dispatch('LOGIN', params)
          .then((res) => {
            if (!res) {
              throw new Error('no response')
            } else if (res.type === 'new') {
              this.submit()
            } else if (res.code === 'auth') {
              // if (this.autoLogin) {
              //   localStorage.accessToken = res.token
              // }
              // this.$store.dispatch('FETCH_USERINFO').then((res) => {
              // this.$store.commit('loading', false)

              //   try {
              //     loginSuccess(this.email, res.token)
              //   } catch (error) {
              //     this.$store.commit('loading', false)
              //     console.log(error)
              //   }
              //   if (!res.data.user.auth_sms || res.data.user.auth_sms === 'N') {
              //     this.$router.push('/phone/verify')
              //     return
              //   }

              //   this.$store.commit('activeMenu', 'home')
              // })
              this.$store.commit('loading', false)
              this.$router.replace({
                name: 'verify',
                params: { phone: params.phone  ,firstLogin : res.first },
              })
            } else if (res.code === 'email') {
              this.$store
                .dispatch('SEND_VERIFY_CODE', {
                  email: params.email,
                })
                .then((response) => {
                  this.$store.commit('loading', false)
                  if (response.data.status) {
                    this.$router.push({
                      name: 'verify',
                      params: { email: params.email , firstLogin : res.first },
                    })
                  }
                })

            }else if(res.code = 'notPhoneType') {
              
              this.$store.commit('loading', false)
              this.alert = true
              this.errors = '올바른 휴대폰 번호를 입력해주세요.' ;

            } else if (res.code === 'invalid') {
              this.$store.commit('loading', false)
              this.alert = true
              this.errors = this.$t('login.errors')
            } else throw res
          })
          .catch((error) => {
            this.$store.commit('loading', false)
            this.alert = true
            this.errors = this.$t('errorServer')
          })
      } else {
        this.$store.commit('loading', false)
        this.alert = true
        this.errors = this.$t('login.errors')
      }
    },
    scrollTo(elem) {
      let target
      if (elem === 'password') target = this.$refs.password
      if (elem === 'email') target = this.$refs.email

      this.$vuetify.goTo(target)
    },
  },
}
</script>

<style scoped>
/* .login-container {
  padding: 4rem 2rem;
  height: 100%;
  max-width: 25rem;
  overflow: auto;
} */
.login-container {
  padding: 4rem 2rem;
  height: 100%;
  max-width: 25rem;
  overflow: auto;
  background: linear-gradient(
    to bottom,
    #f0f0f0,
    #797878
  ); /* 캡처 이미지의 그라데이션 색상 */
}

.web3pays-subtitle {
  font-size: 1.1rem; /* 설명 텍스트 크기 */
  line-height: 1.5;
}
.links {
  display: flex;
  align-items: center;
}
.link-item {
  margin-left: 1rem;
}
.links a {
  color: #000;
}
</style>
